import styled from '@emotion/styled';
import type { FunctionComponent, PropsWithChildren } from 'react';

const MosaicSkeleton = styled.div({
    height: '508px',
    width: '303px',
});

export const SkillMosaicWrapper: FunctionComponent<PropsWithChildren> = ({ children }) => {
    return <MosaicSkeleton>{children}</MosaicSkeleton>;
};
